import { CASHIER_VISUAL } from "./CashierConfig";
import type { CSSProperties } from "react";

/** 将 CashierConfig 中的视觉项注入为 CSS 变量，挂到 .cashier-shell 即可生效 */
export function buildCashierVisualStyle(): CSSProperties {
  const v = CASHIER_VISUAL;
  return {
    "--cashier-web-card-radius": `${v.webCardBorderRadiusPx}px`,
    "--cashier-web-method-tile-radius": `${v.webMethodTileBorderRadiusPx}px`,
    "--cashier-web-order-box-radius": `${v.webOrderBoxBorderRadiusPx}px`,
    "--cashier-web-order-poster-overlap": `${v.webOrderPosterOverlapPx}px`,
    "--cashier-web-back-color": v.webBackLinkColor,
    "--cashier-web-card-foot-padding-top": `${v.webCardFootPaddingTopPx}px`,
    "--cashier-web-card-foot-padding-bottom": `${v.webCardFootPaddingBottomPx}px`,
    "--cashier-web-card-foot-padding-x": `${v.webCardFootPaddingHorizontalPx}px`,
    "--cashier-web-card-vertical-offset-up": `${v.webCardVerticalOffsetUpPx}px`,
    "--cashier-web-qr-size": `${v.webQrCodeSizePx}px`,
    "--cashier-web-qr-box-size": `${v.webQrCodeSizePx + v.webQrCodeBoxPaddingPx * 2}px`,
  } as CSSProperties;
}
